class JoinSection extends HTMLElement {
  // Use class fields for static values and selectors
  static REGISTRATION_URL = 'https://mlee-uat.epixel.link/afl/api/v1/user/without-starter-kit/';
  static API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXAiOiJ3ZWJzaXRlIiwiYXVkIjoiYmFzZS1hcHBsaWNhdGlvbiIsImlhdCI6MTc1MDMyOTg2MiwiaXNzIjoibWxlZS11YXQuZXBpeGVsLmxpbmsifQ.s_jL6g3lKqKgga4SfjrFgmEN3PzyqrbtwVyTZskx5sw';

  // Element references as private fields
  #form;
  #submitButton;
  #formErrorsWrapper;
  #spinner;
  #successMsg;

  constructor() {
    super();
    // Defer DOM queries to connectedCallback for best practice
    this.onSubmitHandler = this.submitHandler.bind(this);
  }

  connectedCallback() {
    // Query and cache elements when attached to DOM
    this.#form = this.querySelector('[data-join="form"]');
    this.#submitButton = this.#form.querySelector('[type="submit"]');
    this.#formErrorsWrapper = this.#form.querySelector('[data-join="form-errors"]');
    this.#spinner = this.#submitButton.querySelector('[data-join="loading"]');
    this.#successMsg = this.querySelector('[data-join="success_msg"]');

    this.#form.addEventListener('submit', this.onSubmitHandler);
  }

  disconnectedCallback() {
    this.#form?.removeEventListener('submit', this.onSubmitHandler);
  }

  async submitHandler(event) {
    event.preventDefault();
    this.#clearErrors();
    this.#setLoading(true);

    try {
      const formData = this.#parseFormData();
      const response = await fetch(JoinSection.REGISTRATION_URL, {
        method: 'POST',
        headers: {
          'apikey': JoinSection.API_KEY,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        this.#displayResponseErrors(data);
        return;
      }

      this.#form.classList.add('hidden');
      this.#form.reset();
      this.#successMsg.classList.remove('hidden');
    } catch (error) {
      console.error('Error joining user:', error);
      this.#formErrorsWrapper.innerHTML = 'An unexpected error occurred. Please try again.';
      this.#formErrorsWrapper.classList.remove('hidden');
    } finally {
      this.#setLoading(false);
    }
  }

  #displayResponseErrors(data) {
    let messages = [];
    if (data?.errors?.detail) {
      messages = data.errors.detail.map(e =>
        Array.isArray(e.message) ? e.message.join('<br>') : e.message
      );
    }
    this.#formErrorsWrapper.innerHTML = messages.join('<br>');
    this.#formErrorsWrapper.classList.remove('hidden');
  }

  #clearErrors() {
    this.#formErrorsWrapper.innerHTML = '';
    this.#formErrorsWrapper.classList.add('hidden');
  }

  #setLoading(isLoading) {
    this.#submitButton.disabled = isLoading;
    this.#spinner.classList.toggle('hidden', !isLoading);
  }

  #parseFormData() {
    return Object.fromEntries(new FormData(this.#form));
  }
}

customElements.define('join-section', JoinSection);

